import { Link } from 'react-router-dom';
import type { Article } from '@/mocks/articles';

export default function ArticleCard({ article, compact = false }: { article: Article; compact?: boolean }) {
  return (
    <article className="group flex h-full flex-col overflow-hidden rounded-xl border border-background-200/70 bg-background-50 transition-all duration-300 hover:-translate-y-1 hover:border-primary-200">
      <Link to={`/article/${article.id}`} className="block overflow-hidden">
        <div className="relative h-44 w-full overflow-hidden md:h-48">
          <img
            src={article.cover}
            alt={article.title}
            className="h-full w-full object-cover object-top transition-transform duration-500 group-hover:scale-105"
          />
          <span className="absolute left-3 top-3 rounded-full bg-background-950/60 px-2.5 py-1 text-xs text-background-50 backdrop-blur-sm">
            {article.categoryLabel}
          </span>
        </div>
      </Link>
      <div className={`flex flex-1 flex-col ${compact ? 'p-4' : 'p-5'}`}>
        <div className="flex flex-wrap items-center gap-2 text-xs text-foreground-500">
          <span>{article.date}</span>
          <span className="text-background-300">·</span>
          <span>{article.readTime}</span>
        </div>
        <h3 className="mt-2 font-heading text-base font-bold leading-snug text-foreground-950 transition-colors group-hover:text-primary-700 md:text-lg">
          <Link to={`/article/${article.id}`}>{article.title}</Link>
        </h3>
        <p className="mt-2 line-clamp-2 flex-1 text-sm leading-6 text-foreground-600">{article.excerpt}</p>
        <div className="mt-3 flex flex-wrap items-center gap-1.5">
          {article.tags.slice(0, 2).map((t) => (
            <span key={t} className="rounded-md bg-secondary-100 px-2 py-0.5 text-xs text-secondary-900">
              #{t}
            </span>
          ))}
        </div>
      </div>
    </article>
  );
}